var _defs, _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 630.26 321.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1275,379.75H644.77V416H685V701.14h22.4V466.8h309.26V662.74h182.88V416h12.34V701.14h22.4V416H1275ZM707.35,416H913.57v38.92H707.35Zm218.12,38.92V416h91.14v38.92Zm103,195.94V501.15H1187.6v149.7Zm159.09-161.6H1028.51V416H1187.6Z",
    transform: "translate(-644.77 -379.75)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.66,
    y: 46.54,
    width: 45.79,
    height: 11.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440.27,
    y: 46.54,
    width: 45.79,
    height: 11.89
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.91,
    y: 143.31,
    width: 11.89,
    height: 106.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.6ff6ec25e5498bde91da589d4c511bcf.svg";
export { ForwardRef as ReactComponent };